import EventAccordion from '../../core/components/EventAccordion'
import { valueIsDefined } from '../../core/utils/utils'


class CreditNoteFeedAccordion extends EventAccordion {

    fetchData = async () => {
        const { creditNoteID } = this.props

        if (valueIsDefined(creditNoteID)) {
            const endpoint = DjangoUrls["invoices:api-credit-notes-feed-list"](window.MARKETPLACE_ENTITY_SLUG, creditNoteID)
            const response = await fetch(endpoint)
            return await response.json()
        }
        else {
            return null
        }
    }

    getTitle = () => {
        return "Credit Note Timeline"
    }

    getEmphasis = () => {
        return "time"
    }
}

export default CreditNoteFeedAccordion;
